import type { PriceMaskType } from '../shared';

export const enum PriceRibbonDayTileType {
  LoadingPrice = 'loadingPrice',
  AvailablePrice = 'availablePrice',
  NoAvailability = 'noAvailability',
  AlternativePrice = 'alternativePrice',
  NotSearched = 'notSearched',
}

export interface PriceRibbonDayLoadingPriceTile {
  type: PriceRibbonDayTileType.LoadingPrice;
}

export interface PriceRibbonDayAvailablePriceTile {
  type: PriceRibbonDayTileType.AvailablePrice;
  priceMaskType: PriceMaskType;
  priceWithCurrency: string;
}

export interface PriceRibbonAlternativePriceTile {
  type: PriceRibbonDayTileType.AlternativePrice;
  priceMaskType: PriceMaskType;
  priceWithCurrency: string;
}

export interface PriceRibbonDayNoAvailabilityTile {
  type: PriceRibbonDayTileType.NoAvailability;
}

export interface PriceRibbonDayNotSearchedTile {
  type: PriceRibbonDayTileType.NotSearched;
}

export type PriceRibbonDayTile =
  | PriceRibbonDayLoadingPriceTile
  | PriceRibbonDayAvailablePriceTile
  | PriceRibbonAlternativePriceTile
  | PriceRibbonDayNoAvailabilityTile
  | PriceRibbonDayNotSearchedTile;

export const enum PriceRibbonDayStatus {
  Default = 'default',
  Selected = 'selected',
  Suggested = 'suggested',
}

export interface PriceRibbonDay {
  date: string;
  dayMonth: string;
  weekday: string;
  status: PriceRibbonDayStatus;
  state: PriceRibbonDayTile;
}

export interface PriceRibbonMonth {
  month: string;
  monthShort: string;
  year: string;
  isExtended: boolean;
  firstDayInMonthISO: string;
  days: PriceRibbonDay[];
}
